import type { FC } from 'react';
import React from 'react';
import { EmptyState } from 'venn-components';

const NoFactors: FC<React.PropsWithChildren<unknown>> = () => (
  <EmptyState header="No factors selected." message="Please select at least one factor to run analysis." />
);

export default NoFactors;
